import React from "react";

import obaLogo from "../../assests/oba_logo_nbg.png";

export default function OBAOverviewComponent() {
  return (
    <div
      className="rounded-3 border-vcg-muted p-4 p-lg-5 mb-5"
      style={{ backgroundColor: "#fff" }}
      data-aos="fade-left"
    >
      {/* Heading */}
      <div className="mb-4">
        <h3 className="fw-bold">About the Old Boys' Association</h3>
      </div>

      {/* Content */}
      <div
        className="text-secondary"
        style={{
          textAlign: "justify",
          lineHeight: "1.8",
        }}
      >
        <p>
          The Old Boys’ Association of Vidyaloka College is the official alumni
          organization representing past students of Vidyaloka College in Galle.
          The Association plays an important role in maintaining strong
          connections among former students while supporting the growth and
          development of the school.
        </p>

        <p>
          The Association is governed by a duly elected Executive Committee that
          functions in accordance with the Constitution of the Old Boys’
          Association. This committee is elected at the Annual General Meeting
          of the Association, ensuring transparent leadership and collective
          decision making.
        </p>

        {/* Official Emblem */}
        <div className="text-center my-5">
          <img
            src={obaLogo}
            alt="Official OBA Emblem"
            className="img-fluid"
            style={{
              maxHeight: "220px",
              objectFit: "contain",
            }}
          />

          <p className="text-muted small mt-3 mb-0">
            The official emblem of the Vidyaloka College Old Boys' Association.
          </p>
        </div>

        <p>
          By virtue of office, the Principal of Vidyaloka College serves as the
          President of the Executive Committee. The administration and
          initiatives of the Association are led by the Active President,
          together with the executive officers and committee members to carry
          out the objectives of the Association.
        </p>

        <p>
          The office of the Old Boys’ Association is located within the school
          premises, allowing close coordination with the administration of
          Vidyaloka College and strengthening the bond between the Association
          and the school community.
        </p>

        <p className="mb-0">
          Through unity, leadership, and service, the Association continues to
          inspire alumni to give back to their alma mater while creating a
          lasting legacy for future generations.
        </p>
      </div>
    </div>
  );
}
